import { useState } from "react";
import Input from "../../UI/Input/Input";
import LanguageIcon from "@mui/icons-material/Language";
import Select from "../../UI/Select/Select";
import BaseButton from "../../UI/BaseButton/BaseButton";
import { useEffect } from "react";
import { CRMDepositFunds, getCustomerAccount, getReceipts } from "../../../util/API/transfer";
import { useSelector } from "react-redux";
import CustomAlert from "../../UI/CustomAlert/CustomAlert";
import { CircularProgress, Stack } from "@mui/material";
import PinPad from "../../PinPad/PinPad";
import Box from "@mui/material/Box";
import { countryList } from "../../../constants/countrylist";
import { getErrorMessage, getErrorMessage2 } from "../../../util/utilfunctions/utilFunctions";

function AgentDeposits() {
  const [inputValue, setInputValue] = useState("");
  const [selectedOption, setSelectedOption] = useState("");
  const [transactionInformation, setTransactionInformation] = useState([]);
  const [fee, setFee] = useState(0.0);
  const [total, setTotal] = useState(0.0);
  const [receipt, setReceipt] = useState(false);
  const [receiptIDData, setReceiptIDData] = useState({});
  const [disabled, setDisabled] = useState(false);
  const [showPinPad, setShowPinPad] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [alert, setAlert] = useState(
    {
      showAlert: false,
      severity: "error",
      header: "",
      message: ""
    }
  );

  let isOperator = sessionStorage.getItem("isOperator");
  let configVariables = useSelector((state) => state.config.baseConfig);
  const user = useSelector((state) => state.usersList.userID);
  let pin = sessionStorage.getItem("pin");
  let agent = JSON.parse(sessionStorage.getItem("user")).payload?.body;
  const pinConfiguration = useSelector((state) => state.login.pinConfiguration);
  const parentuserid = sessionStorage.getItem("parentuserid");
  let isAutoRetry;

  // Dummy function to calculate fee, this should be replaced with actual logic
  const calculateFee = () => {
    // Set static fee for demonstration purposes
    const calculatedFee = 0.0;
    setFee(calculatedFee);
    if (inputValue === "") {
      setTotal(0.0);
      return;
    }
    setTotal(parseFloat(inputValue) - calculatedFee);
  };

  const getAccounts = async () => {
    const response = await getCustomerAccount(user['User'].id);
    const records = response.ServiceData.record.filter(
      (record) => record.Vtransfersourcepis.piid === "229"
    );

    // Filter out duplicates based on unique identifiers (e.g., account ID)
    const uniqueRecords = records.filter(
      (record, index, self) =>
        index === self.findIndex(
          (r) => r.Vtransfersourcepis.acctID === record.Vtransfersourcepis.acctID
        )
    );

    setTransactionInformation(uniqueRecords);
  };

  useEffect(() => {
    getAccounts();
  }, []);

  const options = transactionInformation.map((record) => ({
    key: record.Vtransfersourcepis.acctID,
    value: record.Vtransfersourcepis.friendlyname,
    label: record.Vtransfersourcepis.friendlyname + " - " + record.Vtransfersourcepis.currcode + " " + record.Vtransfersourcepis.balance
  }));

  useEffect(() => {
    if (options) {
      setSelectedOption(options[0]?.value)
    }
  }, [options])

  const handleReceipt = async (event) => {
    event.preventDefault();
    try{
      const response = await getReceipts(
        receiptIDData.forCustomer.trngrpid
      ).then((response) => {
        window.open(
          configVariables.baseURL + 
          configVariables.receiptExtension + 
          "/mod_genreceipt.php?type=deposit&id=" + 
          response.ServiceData.Transreceipt.groupID, "_blank"
        );
      })
    }
    catch(error){
    }
  };

  const handleConfirm = (event, pin) => {
    let PIN = pin.join('');
    handleDeposit(event, PIN);
    setShowPinPad(false);
  };

  const handleDeposit = async (event, pin) => {
    // Logic to handle deposit
    if (!inputValue) {  
      setAlert({
        showAlert: true,
        severity: "error",
        message: "Please enter a value to be deposited",
        header: "Error"
      });
      return;
    }

    setReceipt(false);
    event.preventDefault();
    try{
      setIsLoading(true);
      const response = await CRMDepositFunds(
        transactionInformation[0]['Vtransfersourcepis'].id, // transaction account
        countryList.filter((country) => country.value === user['User'].countryid)[0]?.label, // user
        user['User'].firstName,
        user['User'].lastName,
        user['User'].telephoneno,
        transactionInformation[0]['Vtransfersourcepis'].userid, // transaction account
        parseFloat(inputValue),
        total,
        user['User'].langID,
        user['User'].accountID,
        user['User'].address1,
        user['User'].address2,
        user['User'].cityname,
        pin,
        agent['User'].id,
        agent['User'].firstName, 
        agent['User'].lastName,
        agent['User'].cityname,
        countryList.filter((country) => country.value === agent['User'].countryid)[0]?.label, // agent
        parentuserid, // parentuserid
        isOperator,
        isAutoRetry
      ).then((response) => {
        if(response.Status === "1") {
        setReceiptIDData(response);
        setDisabled(true);
        setAlert({
          showAlert: true,
          severity: "success",
          message: "Deposit Completed",
          header: "Congratulations!"
        });
        if (pinConfiguration === "once") {
          sessionStorage.setItem("pin", pin);
        }
        setReceipt(true);
        setInputValue("");
        }
        else {
          let errorMsg = getErrorMessage2(response, isAutoRetry = false);
          setAlert({
            showAlert: true,
            severity: "error",
            message: "Deposit Failed: " + errorMsg,
            header: "Error!"
          });
        }
      });
    }
    catch(error){
    } finally {
      setIsLoading(false);
    }
    getAccounts();
  };

  const handleDepositClick = () => {
    if (!inputValue || parseFloat(inputValue) === 0) {
      setAlert({
        showAlert: true,
        severity: "error",
        message: "Please enter a value greater than 0 to be deposited",
        header: "Error!"
      });
      return;
    }
    setShowPinPad(true);
  };
  

  return (
    <Box className="consumer-deposit-container">
      <Box className="d-flex justify-content-center gap-3 align-items-center">
        <LanguageIcon />
        <Box className="header">Consumer Deposit</Box>
      </Box>
      {isLoading == true ? (
        <Box
            sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                overflow: "hidden",
            }}
        >
            <CircularProgress />
        </Box>
      ) : (
        <Box className="customer-deposit-inputs">
          <form>
            <Select
              name="myselect"
              label="Account"
              value={selectedOption}
              onChange={(e) => setSelectedOption(e.target.value)}
              options={options}
            />
            <Input
              name="sendAmount"
              label="Deposit Amount"
              value={inputValue}
              type="number"
              textAlign="right"
              onChange={(e) => {
                const newValue = e.target.value;
                if (newValue === "" || (!isNaN(newValue) && Number(newValue) >= 0)) {
                  setInputValue(newValue);
                } else {
                  setAlert({
                    showAlert: true,
                    severity: "error",
                    message: "Please enter a valid amount.",
                    header: "Error!"
                  });
                }
              }}
              onBlur={() => calculateFee()}
            />
            <Box className="info-box">
              <Box className="fee d-flex justify-content-end gap-2 align-items-center">
                Fee: <Box className="info-box-info">${fee.toFixed(2)}</Box>
              </Box>
              <Box className="total d-flex justify-content-end gap-2 align-items-center">
                Total: <Box className="info-box-info">${total.toFixed(2)}</Box>
              </Box>
            </Box>
            <Stack spacing={receipt ? 2 : 1} direction="row" className="button-group d-flex justify-content-end mt-3">
              <BaseButton 
                buttonText={"Submit"} 
                onClick={(e) => pin ? handleDeposit(e, pin) : pinConfiguration === "never" ? handleDeposit(e, '0000') : handleDepositClick()}
              />
              {receipt ? <BaseButton 
                buttonText={"Receipt"} 
                buttonStyle="secondary-button-style"
                onClick={(event) => {handleReceipt(event)}}
              /> : null}
            </Stack>
          </form>
        </Box>
      )}
      
      <CustomAlert severity={alert.severity} show={alert.showAlert} header={alert.header} message={alert.message} onClick={(prev) => setAlert({...prev, showAlert: false})} autoclose={alert.severity === "error" ? false : true} />
      {showPinPad && <PinPad show={showPinPad} handleConfirm={handleConfirm} onClick={() => setShowPinPad(false)} />}
    </Box>
  );
}

export default AgentDeposits;
